import * as React from 'react';
import mainColors from '../../../themes/main-colors';

type BusinessIconProps = React.SVGProps<SVGSVGElement> & {
  isSelected?: boolean;

  /** Width/Height in px (default: 24) */
  size?: number | string;
};

export const BusinessIcon: React.FC<BusinessIconProps> = ({
  isSelected = false,
  size = 24,
  ...props
}) => {
  const stroke = isSelected ? mainColors.white : mainColors.sparkBlue;

  // Common stroke style for st0 and st1
  const common = {
    fill: 'none',
    stroke,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    strokeMiterlimit: 10,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox={'0 0 55 55'}
      width={size}
      height={size}
      {...props}
    >
      {/* st0 paths (default stroke width) */}
      <path
        d="m140 28.3-7.8-7.5V9.3h-7.5v4.4L117 6.2c-.4-.3-.9-.3-1.3 0L92.6 28.3c-.4.4-.4 1 0 1.3l1.5 1.5c.4.4.9.4 1.3 0l20.3-18.5c.4-.3.9-.3 1.3 0l20.3 18.5c.4.3.9.3 1.3 0l1.5-1.5c.3-.3.3-.9-.1-1.3"
        {...common}
      />
      <path
        d="M117 12.7c-.4-.3-.9-.3-1.3 0L97.6 29.3v19.8h37.5V29.3z"
        {...common}
      />
      <path
        d="M107.3 30.6h10v14.5h-10zM122.3 30.6v7h6v-7zM104.3 45.1h16v4h-16z"
        {...common}
      />

      {/* st1 paths (strokeWidth 1.1184) */}
      <path
        d="M1 17.3v2.4c0 3 2.4 5.4 5.3 5.4s5.3-2.4 5.3-5.4v-2.4l2.4-6.9H5.7z"
        {...common}
        strokeWidth={1.1184}
      />
      <path
        d="M11.6 17.3v2.4c0 3 2.4 5.4 5.3 5.4s5.3-2.4 5.3-5.4v-2.4l1.2-6.9H14z"
        {...common}
        strokeWidth={1.1184}
      />
      <path
        d="M22.2 17.3v2.4c0 3 2.4 5.4 5.3 5.4s5.3-2.4 5.3-5.4v-2.4l-1.2-6.9h-8.2z"
        {...common}
        strokeWidth={1.1184}
      />
      <path
        d="M32.8 17.3v2.4c0 3 2.4 5.4 5.3 5.4s5.3-2.4 5.3-5.4v-2.4L41 10.5h-9.4z"
        {...common}
        strokeWidth={1.1184}
      />
      <path
        d="M43.4 17.3v2.4c0 3 2.4 5.4 5.3 5.4s5.3-2.4 5.3-5.4v-2.4l-4.7-6.9H41zM5.7 5.9h43.5v4.5H5.7z"
        {...common}
        strokeWidth={1.1184}
      />
      <path
        d="M43.4 19.8c0 3-2.4 5.4-5.3 5.4s-5.3-2.4-5.3-5.4c0 3-2.4 5.4-5.3 5.4s-5.3-2.4-5.3-5.4c0 3-2.4 5.4-5.3 5.4s-5.3-2.4-5.3-5.4c0 3-2.4 5.4-5.3 5.4V49h42.3V25.2c-2.9 0-5.2-2.4-5.2-5.4M4.1 49h46.7v.1H4.1z"
        {...common}
        strokeWidth={1.1184}
      />
      <path
        d="M29.9 37.7c0-3.1 2.5-5.7 5.5-5.7s5.5 2.5 5.5 5.7V49h-11zM21.8 41.1h-6.6c-.6 0-1.1-.5-1.1-1.1v-6.8c0-.6.5-1.1 1.1-1.1h6.6c.6 0 1.1.5 1.1 1.1V40c0 .6-.5 1.1-1.1 1.1"
        {...common}
        strokeWidth={1.1184}
      />
    </svg>
  );
};
